import { HeadlineText } from "@classdojo/web/nessie";
import { IdeasCheckmarkIcon } from "./IdeasIcons";

export type Person = {
  _id: string;
  avatar: string;
  firstName: string;
};

type PersonListItemProps = {
  person: Person;
  selected?: boolean;
  toggle: (personId: string) => void;
};

export default function PersonListItem({ person, selected = true, toggle }: PersonListItemProps) {
  return (
    <div
      onClick={() => toggle(person._id)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "dt_m",
        position: "relative",
      }}
    >
      <div
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: 50,
          marginRight: "dt_s",
          position: "relative",
        }}
      >
        <img src={person.avatar} sx={{ maxHeight: 42 }} />
      </div>
      <div sx={{ flex: 1, position: "relative" }}>
        <HeadlineText as="h2" level={2}>
          {person.firstName}
        </HeadlineText>
      </div>
      {selected && (
        <div sx={{ position: "relative" }}>
          <IdeasCheckmarkIcon size="m" color="dt_content_accent" />
        </div>
      )}
    </div>
  );
}
